/* Ayazure – Educational PDP behaviour (gallery, bundle price sync, sticky ATC, smooth scroll, countdown) */
(function () {
  'use strict';

  function initGallery(root) {
    var track = root.querySelector('[data-az-track]');
    var thumbs = root.querySelectorAll('[data-az-thumb]');
    var count = root.querySelector('[data-az-count]');
    if (!track) return;
    var slides = track.children;

    function setActive(i) {
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, Math.min(i, slides.length - 1)));
        ticking = false;
      });
    }, { passive: true });
    setActive(0);
  }

  function initBuyForm(form) {
    var label = form.querySelector('[data-az-btn-price]');
    // The subscription option only works with this script (it fills selling_plan), so it is revealed here
    var planInput = form.querySelector('[data-az-selling-plan]');
    if (planInput) {
      form.querySelectorAll('[data-az-sub]').forEach(function (el) { el.hidden = false; });
    }
    // Browsers restore the last clicked bundle / insurance choice on reload and back navigation;
    // always start from the server-rendered default (editor setting or ?variant=) instead
    function resetToDefault() {
      form.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (input) {
        input.checked = input.defaultChecked;
      });
    }
    resetToDefault();
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      resetToDefault();
      form.dispatchEvent(new Event('change'));
    });
    // "Ersparnis im Checkout": the chosen option's saving goes along as a visible line item property
    var savingsInput = form.querySelector('[data-az-savings-prop]');
    function sync() {
      var checked = form.querySelector('input[name="id"]:checked');
      if (!checked) return;
      if (planInput) {
        var plan = checked.dataset.sellingPlan || '';
        planInput.value = plan;
        planInput.disabled = !plan;
      }
      if (savingsInput) {
        savingsInput.value = checked.dataset.savings || '';
        savingsInput.disabled = !savingsInput.value;
      }
      if (label) label.textContent = checked.dataset.price || '';
      document.dispatchEvent(new CustomEvent('az:variant', {
        detail: { title: checked.dataset.title, price: checked.dataset.price, compare: checked.dataset.compare || '' }
      }));
    }
    form.addEventListener('change', sync);
    sync();
    initInsurance(form, planInput);
    // Upsell box: revealed only with the script, because initBuySubmit adds the item
    if (window.fetch) form.querySelectorAll('[data-az-addon-box]').forEach(function (el) { el.hidden = false; });
    // The upsell rows are one choice: ticking one clears the others
    var addonChecks = form.querySelectorAll('[data-az-addon]');
    addonChecks.forEach(function (c) {
      c.addEventListener('change', function () {
        if (c.checked) addonChecks.forEach(function (o) { if (o !== c) o.checked = false; });
      });
    });
    initBuySubmit(form, planInput);
    initCards(form);
  }

  // Buying starts a fresh cart (like the Funnelish /cart/clear links): everything already in the cart, including
  // other products, is removed and only the current choice goes to checkout. Shoppers who come back from checkout
  // and tap again would otherwise land there with 2x + 3x or leftovers from other sales pages.
  // Shipping insurance follows the current choice (one item when ticked, never with the subscription).
  function initBuySubmit(form, planInput) {
    if (!window.fetch) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var box = form.querySelector('[data-az-insurance]');
    var busy = false;

    function setBusy(on) {
      busy = on;
      form.querySelectorAll('button[type="submit"], [data-az-card-variant]').forEach(function (b) {
        b.disabled = on;
        if (on) b.setAttribute('aria-busy', 'true');
        else b.removeAttribute('aria-busy');
      });
    }

    async function post(path, body) {
      var res = await fetch(root + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error(path + ' failed');
    }

    async function replaceAndBuy() {
      var checked = form.querySelector('input[name="id"]:checked');
      if (!checked) throw new Error('no variant');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var item = { id: Number(checked.value), quantity: Number(qtyInput ? qtyInput.value : 1) || 1 };
      var subscription = !!(planInput && !planInput.disabled && planInput.value);
      if (subscription) item.selling_plan = Number(planInput.value);
      var savingsInput = form.querySelector('[data-az-savings-prop]');
      if (savingsInput && !savingsInput.disabled && savingsInput.value) {
        var key = savingsInput.name.replace(/^properties\[(.*)\]$/, '$1');
        item.properties = {};
        item.properties[key] = savingsInput.value;
      }
      // The subscription includes shipping insurance, so the paid item is never added with it
      var wantInsurance = !!(box && box.checked && !subscription);
      var insuranceId = box ? box.value : '';

      await post('cart/clear.js', {});

      var items = [item];
      if (wantInsurance && insuranceId) items.push({ id: Number(insuranceId), quantity: 1 });
      // Opt-in upsell (e.g. refill pads): the ticked row, with any pack or the subscription
      var addonBox = form.querySelector('[data-az-addon]:checked');
      if (addonBox && addonBox.value) items.push({ id: Number(addonBox.value), quantity: 1 });
      await post('cart/add.js', { items: items });
      var returnTo = form.querySelector('input[name="return_to"]');
      window.location.assign(returnTo ? returnTo.value : root + 'cart');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      setBusy(true);
      replaceAndBuy().catch(function () {
        // Never block the purchase: fall back to the normal form (adds without replacing or insurance)
        setBusy(false);
        HTMLFormElement.prototype.submit.call(form);
      });
    });
    // Coming back via the browser's back button restores the page from cache with the buttons still disabled
    window.addEventListener('pageshow', function () { setBusy(false); });
  }

  // Mobile card layout: each card button selects its radio in this form and submits it, so the insurance
  // rules, selling plan and return_to of the one product form apply. CSS shows the cards only on narrow screens.
  function initCards(form) {
    var cards = form.querySelector('[data-az-cards]');
    if (!cards) return;
    form.classList.add('az-buy--cards');
    cards.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-az-card-variant]');
      if (!btn || btn.disabled) return;
      var radio = btn.dataset.azCardPlan
        ? form.querySelector('input[name="id"][data-selling-plan="' + btn.dataset.azCardPlan + '"]')
        : form.querySelector('input[name="id"][value="' + btn.dataset.azCardVariant + '"]:not([data-selling-plan])');
      if (!radio || radio.disabled) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  }

  // Shipping insurance box: revealed only with the script, because initBuySubmit adds the insurance item
  function initInsurance(form, planInput) {
    var box = form.querySelector('[data-az-insurance]');
    if (!box || !window.fetch) return;
    form.querySelectorAll('[data-az-insurance-box]').forEach(function (el) { el.hidden = false; });
    var label = box.closest('label');
    var price = label && label.querySelector('.az-insurance__price');
    var included = label && label.querySelector('.az-insurance__included');

    // The subscription includes shipping insurance: never add the paid item then
    function subscriptionSelected() {
      return !!(planInput && !planInput.disabled && planInput.value);
    }
    function showIncluded() {
      var sub = subscriptionSelected();
      if (label) label.classList.toggle('az-insurance--included', sub);
      if (price && included) { price.hidden = sub; included.hidden = !sub; }
    }
    form.addEventListener('change', showIncluded);
    showIncluded();
  }

  function initSticky(bar) {
    var form = document.getElementById('az-buy-form');
    var hero = document.getElementById('az-hero');
    var btn = bar.querySelector('[data-az-sticky-btn]');
    var price = bar.querySelector('[data-az-sticky-price]');
    var variantTitle = bar.querySelector('[data-az-sticky-variant]');
    var compare = bar.querySelector('[data-az-sticky-compare]');
    var compareValue = bar.querySelector('[data-az-sticky-compare-value]');
    if (!form || !hero) { bar.remove(); return; }

    function show(d) {
      if (price) price.textContent = d.price || '';
      if (variantTitle && d.title) variantTitle.textContent = d.title;
      if (compare && compareValue) {
        compareValue.textContent = d.compare || '';
        compare.hidden = !d.compare;
      }
    }
    // A fixed price (e.g. "CHF 35.– statt CHF 70", the single-pack price) never follows the selection, so the button
    // always returns to the choice instead of buying a pack the bar does not show
    var fixedPrice = bar.dataset.price === 'fixed';
    if (fixedPrice && bar.dataset.fill === 'first-pack') {
      // First pack radio of the hero (e.g. 1x): its title, price and theme "statt" price
      var firstPack = form.querySelector('input[name="id"]');
      if (firstPack && firstPack.dataset.price) {
        show({ price: firstPack.dataset.price, title: firstPack.dataset.title, compare: firstPack.dataset.compare });
      }
    }
    if (!fixedPrice) {
      document.addEventListener('az:variant', function (e) { show(e.detail); });
      var initial = form.querySelector('input[name="id"]:checked');
      if (initial) show({ price: initial.dataset.price, title: initial.dataset.title, compare: initial.dataset.compare });
    }

    btn.addEventListener('click', function () {
      if (fixedPrice || bar.dataset.mode === 'scroll') {
        // 'start' + scroll-margin-top (CSS): the bundle cards at the top of the form land below the sticky header
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });

    // Show whenever the buy box is off-screen and the reader has scrolled past the intro,
    // so long-form pages with the buy box further down also get the bar.
    var formInView = false;
    var threshold = Math.max(400, window.innerHeight * 0.8);
    function update() {
      var show = !formInView && window.scrollY > threshold;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { formInView = en.isIntersecting; });
        update();
      }).observe(form);
      window.addEventListener('scroll', update, { passive: true });
    }
  }

  // Countdown keeps its end time per browser session, so reloads and page changes continue it instead of restarting
  function initCountdown(el) {
    var total = parseInt(el.dataset.seconds, 10);
    if (!total || total < 0) return;
    var parts = {
      h: el.querySelector('[data-az-countdown-part="h"]'),
      m: el.querySelector('[data-az-countdown-part="m"]'),
      s: el.querySelector('[data-az-countdown-part="s"]')
    };
    var key = 'az-countdown-' + (el.dataset.key || '');
    var end = null;
    try { end = parseInt(sessionStorage.getItem(key), 10) || null; } catch (e) { end = null; }
    if (!end) {
      end = Date.now() + total * 1000;
      try { sessionStorage.setItem(key, String(end)); } catch (e) { /* storage blocked: countdown still runs */ }
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    var timer = null;
    function render() {
      var left = Math.max(0, Math.round((end - Date.now()) / 1000));
      if (parts.h) parts.h.textContent = pad(Math.floor(left / 3600));
      if (parts.m) parts.m.textContent = pad(Math.floor((left % 3600) / 60));
      if (parts.s) parts.s.textContent = pad(left % 60);
      if (left === 0 && timer) clearInterval(timer);
    }
    render();
    timer = setInterval(render, 1000);
  }

  function initScrollLinks() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-az-scroll]');
      if (!link) return;
      var target = document.getElementById('az-buy-form') || document.getElementById('az-hero');
      if (!target) return;
      e.preventDefault();
      // 'start' + scroll-margin-top (CSS) keeps the top of a tall form below the sticky header
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // Mobile: move the one buy form into "AZ · Kaufbox-Platz" (e.g. after the FAQ) and back on wide screens
  function initBuySlot() {
    var hero = document.querySelector('.az-hero--slotted');
    if (!hero) return;
    var form = document.getElementById('az-buy-form');
    var home = hero.querySelector('[data-az-buy-home]');
    var target = document.querySelector('[data-az-buy-slot] [data-az-buy-slot-target]');
    if (!form || !home || !target) {
      // No placeholder on this page: show the form in the hero again
      hero.classList.remove('az-hero--slotted');
      return;
    }
    var mq = window.matchMedia('(max-width: 749px)');
    function place() {
      var dest = mq.matches ? target : home;
      if (form.parentNode !== dest) dest.appendChild(form);
    }
    place();
    if (mq.addEventListener) mq.addEventListener('change', place);
  }

  // Loop videos over images (az-loop-video): fetch and play only while near the viewport. The video stays
  // transparent until its first frame plays, so the image underneath never flashes to an empty frame.
  function initLoops() {
    var videos = document.querySelectorAll('video[data-az-loop]');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (!entry.isIntersecting) { v.pause(); return; }
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }, { rootMargin: '200px 0px' });
    videos.forEach(function (v) {
      v.addEventListener('playing', function () { v.parentNode.classList.add('az-loop--on'); }, { once: true });
      io.observe(v);
    });
  }

  function init() {
    initBuySlot();
    initLoops();
    document.querySelectorAll('[data-az-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-az-buy]').forEach(initBuyForm);
    document.querySelectorAll('[data-az-sticky]').forEach(initSticky);
    document.querySelectorAll('[data-az-countdown]').forEach(initCountdown);
    initScrollLinks();
    // Respect reduced-motion: stop autoplaying section videos (controls stay available)
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.az-tm__video').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
